const ObjectWithHasOwn = Object as ObjectConstructor & {
  hasOwn?: (obj: object, prop: PropertyKey) => boolean;
};

if (!ObjectWithHasOwn.hasOwn) {
  ObjectWithHasOwn.hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
}
